module.exports = __webpack_public_path__ + "img/project18_1.png.117c4892.webp";